import { makeStyles, createStyles } from '@material-ui/core/styles'

const WhatsItemListStyles = makeStyles((theme) =>
  createStyles({
    container: {
      paddingTop: '70px',
      paddingLeft: '60px',
      display: 'flex',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: '0px',
      },
      [theme.breakpoints.down('sm')]: {
        // needed for tablet and below
        paddingTop: 50,
        paddingBottom: 50,
      },
      background: 'transparent',
    },
    itemList: {
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    userInfoBox: {
      paddingTop: '40px',
      textAlign: 'center',
    },
  }),
)

export default WhatsItemListStyles
